declare global {
  interface Window {
    webkit?: {
      messageHandlers?: {
        iosCommunication?: {
          postMessage: (message: string) => void;
        };
      };
    };
  }
}

export enum iOSMessages {
  Close = 'close',
  Success = 'success'
}

export const useIOSCommunication = () => {
  const sendMessageToIOS = (message: iOSMessages) => {
    if (window?.webkit?.messageHandlers?.iosCommunication) {
      window.webkit.messageHandlers.iosCommunication.postMessage(message);
    } else {
      // eslint-disable-next-line no-console
      console.error('No message handler found for iOS communication');
    }
  };

  return { sendMessageToIOS };
};
